import { AuthProvider } from "@redotech/redo-customer-portal-app/contexts/auth";
import { CustomerContextProvider } from "@redotech/redo-customer-portal-app/contexts/CustomerContext";
import { FaqContextProvider } from "@redotech/redo-customer-portal-app/contexts/faq";
import { PortalBuilderProvider } from "@redotech/redo-customer-portal-app/contexts/portal-builder";
import { RpcClientContextProvider } from "@redotech/redo-customer-portal-app/contexts/RpcClientContext";
import { SettingsProvider } from "@redotech/redo-customer-portal-app/contexts/settings";
import { UserContextProvider } from "@redotech/redo-customer-portal-app/contexts/user";
import { ReferralProvider } from "@redotech/redo-customer-portal-shared/contexts/referral";
import { CustomSnackbarProvider } from "@redotech/redo-web/snackbar";
import { memo } from "react";
import { Outlet } from "react-router-dom";
import { PickupContextProvider } from "./contexts/PickupContext";

export const Root = memo(function Root() {
  return (
    <SettingsProvider>
      <AuthProvider>
        <RpcClientContextProvider>
          <UserContextProvider>
            <CustomerContextProvider>
              <ReferralProvider>
                <FaqContextProvider>
                  <PickupContextProvider>
                    <PortalBuilderProvider>
                      <CustomSnackbarProvider>
                        <Outlet />
                      </CustomSnackbarProvider>
                    </PortalBuilderProvider>
                  </PickupContextProvider>
                </FaqContextProvider>
              </ReferralProvider>
            </CustomerContextProvider>
          </UserContextProvider>
        </RpcClientContextProvider>
      </AuthProvider>
    </SettingsProvider>
  );
});
